// import { url } from '@/views/visual/dataScreen/js/config';
import { config } from '@/views/visual/dataScreen/js/option/config'; // import request from '@/views/visual/dataScreen/js/axios'

import { axios } from '@/utils/request';
export var getList = function getList(params) {
  return axios({
    url: '/visual/api/list',
    method: 'get',
    params: params
  });
};
export var putFile = function putFile(data) {
  return axios({
    url: '/visual/api/put-file',
    method: 'post',
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: data
  });
};
export var copyObj = function copyObj(id) {
  return axios({
    url: '/visual/api/copy',
    method: 'post',
    params: {
      id: id
    }
  });
};
export var getCategory = function getCategory(params) {
  return axios({
    url: '/sys/dict/getDictItems/visual_category',
    method: 'get',
    params: params
  });
};
export var getObj = function getObj(id) {
  return axios({
    url: '/visual/api/detail',
    method: 'get',
    params: {
      id: id
    }
  });
};
export var uploadImg = function uploadImg(file) {
  return axios({
    url: '/visual/api/put-file',
    method: 'post',
    data: 'file=' + file,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
export var addObj = function addObj(data) {
  return axios({
    url: '/visual/api/save',
    method: 'post',
    data: {
      visual: {
        password: data.password,
        category: data.category,
        status: data.status,
        title: data.title
      },
      config: {
        detail: JSON.stringify(Object.assign(config, {
          name: data.title,
          width: data.width,
          height: data.height
        })),
        component: '[]'
      }
    }
  });
};
export var updateComponent = function updateComponent(data) {
  return axios({
    url: '/visual/api/update',
    method: 'post',
    data: data
  });
};
export var updateObj = function updateObj(data) {
  return axios({
    url: '/visual/api/update',
    method: 'post',
    data: {
      "visual": {
        "id": data.id,
        "password": data.password,
        "category": data.category,
        "status": data.status,
        "title": data.title
      }
    }
  });
};
export var delObj = function delObj(id) {
  return axios({
    url: '/visual/api/remove',
    method: 'post',
    params: {
      ids: id
    }
  });
};